<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Microscopy Cases Needing Review
      </h2>
      <p class="tw-italic tw-text-gray-700">
        
      </p>
    </b-container>

    <b-table striped hover :fields="fields" :items="forms">
      <template v-slot:cell(bloodslide_code)="data">
        <b-link :to="{ name: 'microscopy-review-form', params: { case_id: data.item.microscopy_case_id }}">{{ data.item.bloodslide_code }}</b-link>
      </template>
    </b-table>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "bloodslide_code", label: "Bloodslide Code" },
        { key: "collection_date" },
        { key: "qc_date", label: "QC Date"}
      ],
      forms: []
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/microscopy_qc/get_list").then(response => {
      that.forms = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectsreferred', 
            ['getSubjectsReferredCount', 'setSubjectsReferredCount']),

    refreshSideNavCount(){
      this.getSubjectsReferredCount().then((response) => {
          this.setSubjectsReferredCount(response.data);
      })
    },
  }
};
</script>

<style>
</style>